// import React, { useCallback, useState } from "react";
// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
// import { DatePicker } from "@mui/x-date-pickers/DatePicker";
// import { FormControl, FormLabel } from "@mui/material";
// import style from "../../assets/css/global-fields.module.scss";
// import dayjs from "dayjs";
// import { MobileDatePicker } from "@mui/x-date-pickers";
// import { isMobile } from "react-device-detect";
// import { Clear, Refresh } from "@mui/icons-material";
// import { isStrictValidDate } from "../../constants/helper";
// import GlobalNotificationPopup from "./GlobalNotificationPopup";
// import debounce from "lodash/debounce";

// const GlobalDateField = ({
//   id,
//   name,
//   title,
//   start = false,
//   onChange,
//   onBlur,
//   value = null,
//   minDateValue = null,
//   maxDateValue = null,
//   disablePast = true,
//   disableFuture = false,
//   error = false,
//   helperText,
//   disabled = false,
//   dependentMinValue = null,
//   clearBtn = true,
//   placeH="Select Date"
// }) => {

//   console.log("VALUEEEE",value)
//   const [invalidDateError, setinvalidDateError] = useState(false)
//   let invalidDateErrorMsg = "Invalid date! Please enter a realistic date (e.g., 01/01/2000)."
//   const handleDateChange = useCallback(
//     debounce((newValue, name, onChangeFn) => {
//       if (isStrictValidDate(newValue)) {
//         onChangeFn(newValue, name);
//         setinvalidDateError(false)

//       }
//       else {
//         setinvalidDateError(true)
//         onChangeFn(newValue, name);
//         // error= true
//         // GlobalNotificationPopup({
//         //   type: "error",
//         //   message:
//         //     "Invalid date! Please enter a realistic date (e.g., 01/01/2000).",
//         // });
//       }
//     }, 1000), // debounce for 1000ms
//     [] // make sure the debounce function doesn't recreate on each render
//   );

//   return (
//     <div className={style.proposalDateField}>
//       <FormControl
//         fullWidth
//         className="GDateField"
//         style={{ position: "relative" }}
//       >
//         <LocalizationProvider dateAdapter={AdapterDayjs}>
//           <FormLabel htmlFor={id}>{title}</FormLabel>
//           {isMobile ? (
//             <MobileDatePicker
//               minDate={
//                 disableFuture && dependentMinValue
//                   ? dayjs(dependentMinValue).add(1, "day")
//                   : disableFuture
//                     ? null
//                     : dependentMinValue
//                       ? dayjs(dependentMinValue).add(1, "day")
//                       : minDateValue
//                         ? dayjs(minDateValue).add(2, "day")
//                         : dayjs()
//               }
//               maxDate={maxDateValue ? dayjs(maxDateValue) : null}
//               id={id}
//               value={value ? dayjs(value) : null}
//               // onChange={(newValue) => {
//               //   if (onChange) {
//               //     onChange(newValue, name);
//               //   }
//               // }}
//               onChange={(newValue) => {
//                 if (onChange) {
//                   handleDateChange(newValue, name, onChange);
//                 }
//               }}
//               disablePast={disablePast}
//               disableFuture={disableFuture}
//               // readOnly={disabled}.
//               slotProps={{
//                 textField: {
//                   InputProps: {
//                     readOnly: true,
//                   },
//                   inputProps: {
//                     placeholder: placeH, // ✅ Explicit placeholder
//                     readOnly: true,
//                   },
//                 },
//               }}
//             />
//           ) : (
//             <DatePicker
//               minDate={
//                 disableFuture && dependentMinValue
//                   ? dayjs(dependentMinValue).add(1, "day")
//                   : disableFuture
//                     ? null
//                     : dependentMinValue
//                       ? dayjs(dependentMinValue).add(1, "day")
//                       : minDateValue
//                         ? dayjs(minDateValue).add(2, "day")
//                         : dayjs()
//               }
//               maxDate={maxDateValue ? dayjs(maxDateValue) : null}
//               id={id}
//               value={value ? dayjs(value) : null}
//               // onChange={(newValue) => {
//               //   if (onChange) {
//               //     // onChange(dayjs(newValue).format("MM-DD-YYYY"), name); // Pass newValue and optionally the name for identification
//               //     onChange(newValue, name); // Pass newValue and optionally the name for identification
//               //   }
//               // }}
//               onChange={(newValue) => {
//                 if (onChange) {
//                   handleDateChange(newValue, name, onChange);
//                 }
//               }}
//               slotProps={{
//                 textField: {
//                   size: "small",
//                   placeholder: placeH,
//                   error: invalidDateError ?? error,
//                   helperText: invalidDateError ? invalidDateErrorMsg : helperText || "",
//                   disabled: disabled,
//                   onBlur: () => {
//                     if (onBlur) {
//                       onBlur({ target: { name } });
//                     }
//                   },
//                 },
//                 InputProps: {
//                   readOnly: true,
//                 },
//                 inputProps: {
//                   placeholder: placeH, // ✅ Explicit placeholder
//                   readOnly: true,
//                 },
//                 // Targets the `IconButton` component
//                 openPickerButton: {
//                   color: "primary",
//                 },
//                 // Targets the `InputAdornment` component
//                 inputAdornment: {
//                   position: start ? "start" : "end", // Adjusts position based on `start` prop
//                 },
//               }}
//               renderInput={(params) => (
//                 <div>
//                   <input {...params.inputProps} />
//                 </div>
//               )}
//               disablePast={disablePast}
//               disableFuture={disableFuture}
//               // readOnly={disabled}
//             />
//           )}
//           {(clearBtn || invalidDateError) ? (
//             <div className={style.clearDateBtn} style={(error || invalidDateError) ? { top: "-25px" } : { top: "0px" }}>
//               <Refresh onClick={() => {
//                 onChange("", name);
//                 setinvalidDateError(false);
//               }} />
//               {/* <Refresh onClick={() => onChange("", name)} /> */}
//             </div>
//           ) : null}
//         </LocalizationProvider>
//       </FormControl>
//     </div>
//   );
// };

// export default GlobalDateField;
import React, {useCallback, useState} from "react";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import {LocalizationProvider} from "@mui/x-date-pickers/LocalizationProvider";
import {DatePicker, MobileDatePicker} from "@mui/x-date-pickers";
import {FormControl, FormLabel} from "@mui/material";
import dayjs from "dayjs";
import debounce from "lodash/debounce";
import {isMobile} from "react-device-detect";
import {Refresh} from "@mui/icons-material";

import style from "../../assets/css/global-fields.module.scss";
import {isStrictValidDate} from "../../constants/helper";

const GlobalDateField = ({
  id,
  name,
  title,
  start = false,
  onChange,
  onBlur,
  value = null,
  minDateValue = null,
  maxDateValue = null,
  disablePast = true,
  disableFuture = false,
  error = false,
  helperText,
  disabled = false,
  dependentMinValue = null,
  clearBtn = true,
  placeH = "Select Date",
}) => {
  const [invalidDateError, setInvalidDateError] = useState(false);
  const invalidDateErrorMsg =
    "Invalid date! Please enter a realistic date (e.g., 01/01/2000).";

  const handleDateChange = useCallback(
    debounce((newValue, name, onChangeFn) => {
      if (isStrictValidDate(newValue)) {
        onChangeFn(newValue, name);
        setInvalidDateError(false);
      } else {
        setInvalidDateError(true);
        onChangeFn(newValue, name);
      }
    }, 300),
    []
  );

  // const computedMinDate = disableFuture && dependentMinValue
  //   ? dayjs(dependentMinValue).add(1, "day")
  //   : dependentMinValue
  //   ? dayjs(dependentMinValue).add(1, "day")
  //   : minDateValue
  //   ? dayjs(minDateValue).add(2, "day")
  //   : dayjs();

  const computedMinDate =
    disableFuture && dependentMinValue
      ? dayjs(dependentMinValue).add(1, "day")
      : disableFuture
        ? null
        : dependentMinValue
          ? dayjs(dependentMinValue).add(1, "day")
          : minDateValue
            ? dayjs(minDateValue).add(2, "day")
            : dayjs();

  return (
    <div className={style.proposalDateField}>
      <FormControl
        fullWidth
        className="GDateField"
        style={{position: "relative"}}
      >
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          {/* <FormLabel htmlFor={id}>{title}</FormLabel> */}
          <FormLabel
            htmlFor={id}
            sx={{
              position: "absolute",
              width: 1,
              height: 1,
              padding: 0,
              margin: "-1px",
              overflow: "hidden",
              clip: "rect(0,0,0,0)",
              border: 0,
            }}
          >
            {title || "Select date"}
          </FormLabel>

          {isMobile ? (
            <MobileDatePicker
              id={id}
              value={value ? dayjs(value) : null}
              onChange={(newValue) =>
                handleDateChange(newValue, name, onChange)
              }
              minDate={computedMinDate}
              maxDate={maxDateValue ? dayjs(maxDateValue) : null}
              disabled={disabled}
              disablePast={disablePast}
              disableFuture={disableFuture}
              slotProps={{
                textField: {
                  error: invalidDateError ? invalidDateError : error,
                  helperText: invalidDateError
                    ? invalidDateErrorMsg
                    : helperText
                      ? helperText
                      : "",
                  inputProps: {
                    placeholder: placeH,
                    readOnly: true, // Prevent manual input
                  },
                  InputProps: {
                    readOnly: true,
                    disabled: disabled,
                    "aria-label": title || "Date picker input", // <-- Add aria-label here
                  },
                  helperText: invalidDateError
                    ? invalidDateErrorMsg
                    : helperText || "",
                  onBlur: () => onBlur?.({target: {name}}),
                },
              }}
            />
          ) : (
            <DatePicker
              id={id}
              value={value ? dayjs(value) : null}
              onChange={(newValue) =>
                handleDateChange(newValue, name, onChange)
              }
              minDate={computedMinDate}
              maxDate={maxDateValue ? dayjs(maxDateValue) : null}
              disablePast={disablePast}
              disableFuture={disableFuture}
              disabled={disabled}
              slotProps={{
                textField: {
                  size: "small",
                  error: invalidDateError ? invalidDateError : error,
                  helperText: invalidDateError
                    ? invalidDateErrorMsg
                    : helperText
                      ? helperText
                      : "",
                  onBlur: () => onBlur?.({target: {name}}),
                  inputProps: {
                    placeholder: placeH,
                    readOnly: true, // Prevent manual input
                    "aria-label": title || "Date picker input", // <-- Add aria-label here
                  },
                  InputProps: {
                    readOnly: true,
                    disabled: disabled,
                  },
                },
                openPickerButton: {
                  color: "primary",
                },
                inputAdornment: {
                  position: start ? "start" : "end",
                },
              }}
            />
          )}

          {(clearBtn || invalidDateError) && (
            <div
              className={style.clearDateBtn}
              style={{top: error || invalidDateError ? "-25px" : "0px"}}
            >
              <Refresh
                onClick={() => {
                  onChange("", name);
                  setInvalidDateError(false);
                }}
              />
            </div>
          )}
        </LocalizationProvider>
      </FormControl>
    </div>
  );
};

export default GlobalDateField;
